import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["data-target", "aria-controls"]
const _hoisted_3 = ["textContent"]
const _hoisted_4 = { class: "float-right" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-up" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-down" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["id", "aria-labelledby"]
const _hoisted_12 = { class: "card-body" }
const _hoisted_13 = { class: "items-input" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = ["for"]
const _hoisted_16 = ["id"]
const _hoisted_17 = ["textContent"]
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = ["for"]
const _hoisted_20 = ["id"]
const _hoisted_21 = ["textContent"]
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = ["for"]
const _hoisted_24 = ["id"]
const _hoisted_25 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_number_with_comma = _resolveComponent("number-with-comma")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "card-header",
      id: 'tanpoken-item-header-' + _ctx.item.item.id
    }, [
      _createElementVNode("button", {
        class: "btn btn-link",
        type: "button",
        "data-toggle": "collapse",
        "data-target": '#tanpoken-item-' + _ctx.item.item.id,
        "aria-expanded": "false",
        "aria-controls": 'tanpoken-item-' + _ctx.item.item.id
      }, [
        _createElementVNode("span", {
          textContent: _toDisplayString(_ctx.headerName)
        }, null, 8, _hoisted_3)
      ], 8, _hoisted_2),
      _createElementVNode("div", _hoisted_4, [
        (!_ctx.isFirst)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn btn-link",
              type: "button",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickedUpItem && _ctx.onClickedUpItem(...args)))
            }, _hoisted_6))
          : _createCommentVNode("", true),
        (!_ctx.isLast)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "btn btn-link",
              type: "button",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickedDownItem && _ctx.onClickedDownItem(...args)))
            }, _hoisted_8))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: "btn btn-link",
          type: "button",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClickedTrashItem && _ctx.onClickedTrashItem(...args)))
        }, _hoisted_10)
      ])
    ], 8, _hoisted_1),
    _createElementVNode("div", {
      id: 'tanpoken-item-' + _ctx.item.item.id,
      class: "collapse",
      "aria-labelledby": 'tanpoken-item-header-' + _ctx.item.item.id
    }, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("label", {
              for: 'item-name-' + _ctx.item.item.id
            }, "種類", 8, _hoisted_15),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.itemName }]),
              id: 'item-name-' + _ctx.item.item.id,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.values.itemName) = $event)),
              placeholder: "種類",
              onKeyup: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onChangeInput && _ctx.onChangeInput(...args))),
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onChangeInput && _ctx.onChangeInput(...args)))
            }, null, 42, _hoisted_16), [
              [_vModelText, _ctx.values.itemName]
            ]),
            _createElementVNode("div", {
              class: "invalid-feedback",
              textContent: _toDisplayString(_ctx.errors.itemName)
            }, null, 8, _hoisted_17)
          ]),
          _createVNode(_component_number_with_comma, {
            id: 'tyoubokakaku-' + _ctx.item.item.id,
            number: _ctx.values.kimatsuTyouboKakaku,
            label: "期末帳簿価格",
            error: _ctx.errors.kimatsuTyouboKakaku,
            onChange: _cache[6] || (_cache[6] = (value) => { _ctx.values.kimatsuTyouboKakaku = value; _ctx.onChangeInput() })
          }, null, 8, ["id", "number", "error"]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("label", {
              for: 'shurui-' + _ctx.item.item.id
            }, "担保権の種類", 8, _hoisted_19),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.tanpokenShurui }]),
              id: 'shurui-' + _ctx.item.item.id,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.values.tanpokenShurui) = $event)),
              placeholder: "担保権の種類",
              onKeyup: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onChangeInput && _ctx.onChangeInput(...args))),
              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onChangeInput && _ctx.onChangeInput(...args)))
            }, null, 42, _hoisted_20), [
              [_vModelText, _ctx.values.tanpokenShurui]
            ]),
            _createElementVNode("div", {
              class: "invalid-feedback",
              textContent: _toDisplayString(_ctx.errors.tanpokenShurui)
            }, null, 8, _hoisted_21)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("label", {
              for: 'saimunaiyou-' + _ctx.item.item.id
            }, "債務の内容", 8, _hoisted_23),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.saimuNaiyou }]),
              id: 'saimunaiyou-' + _ctx.item.item.id,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.values.saimuNaiyou) = $event)),
              placeholder: "債務の内容",
              onKeyup: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onChangeInput && _ctx.onChangeInput(...args))),
              onChange: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.onChangeInput && _ctx.onChangeInput(...args)))
            }, null, 42, _hoisted_24), [
              [_vModelText, _ctx.values.saimuNaiyou]
            ]),
            _createElementVNode("div", {
              class: "invalid-feedback",
              textContent: _toDisplayString(_ctx.errors.saimuNaiyou)
            }, null, 8, _hoisted_25)
          ]),
          _createVNode(_component_number_with_comma, {
            id: 'kimatsu-saimu-zandaka-' + _ctx.item.item.id,
            number: _ctx.values.kimatsuSaimuZandaka,
            label: "期末債務残高",
            error: _ctx.errors.kimatsuSaimuZandaka,
            onChange: _cache[13] || (_cache[13] = (value) => { _ctx.values.kimatsuSaimuZandaka = value; _ctx.onChangeInput() })
          }, null, 8, ["id", "number", "error"])
        ])
      ])
    ], 8, _hoisted_11)
  ]))
}